import type { OcsPatchEntryInput, WriteOcsSettingsResult } from "owa-graph-schema";
import { lazyWriteOcsSettings } from "owa-ocs-service-gql";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getAccountScopeUserSettings } from "owa-session-store";

export default function saveOcsShowPreviewLinesSetting(showPreviewLinesInListView: number): Promise<WriteOcsSettingsResult | undefined> {
    const newValue: number = showPreviewLinesInListView;
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const ocsShowPreviewLinesPatch: OcsPatchEntryInput = {
        name: "mail_showpreviewlinesinlistview",
        value: newValue.toString(),
        type: "INT",
        scope: getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress || "",
        itemClass: "RoamingSetting",
    };
    return lazyWriteOcsSettings.importAndExecute(mailboxInfo, "ACCOUNT", [ocsShowPreviewLinesPatch], "setShowPreviewLinesInListView" /* actionName */);
}
